import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  date: dayjs(),
  customer: null,
  orderNo: 0,
  billNo: 0,
  other: 0,
  isRestaurant: false,
  isInvoice: false,
  tax: 0,
  taxAmt: 0,
  totalQty: 0,
  total: 0,
  netTotal: 0,
  holdingStatus: 2,
  BatchNo: 0,
  discAmt: 0,
  editMode:false,

  balance: 0,
  bank: null,
  bankAmount: 0,
  cashAmount: 0,
  cashReceived: 0,
  netAmount: 0,
  narration: "",
  type: "Cash",
  split: false,
  refetch: false,
};

const posSlice = createSlice({
  name: "posSlice",
  initialState,
  reducers: {
    updateOrder: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetOrder: (state) => ({
      ...initialState,
      isRestaurant: state.isRestaurant,
      isInvoice: state.isInvoice,
      refetch: state.refetch,
      date: dayjs(),
    }),
  },
});

export const { updateOrder, resetOrder } = posSlice.actions;

export default posSlice.reducer;
